import { render } from "./actual_baremos.vue?vue&type=template&id=6c138de2&scoped=true"
import script from "./actual_baremos.vue?vue&type=script&lang=js"
export * from "./actual_baremos.vue?vue&type=script&lang=js"

import "./actual_baremos.vue?vue&type=style&index=0&id=6c138de2&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c138de2"]])

export default __exports__